<template>
	<div>
		<el-dialog width="860px" :visible.sync="dialogVisible" center>
			<div class="titleDialog" slot="title">
				<p>个人信息确认</p>
				<i></i>
			</div>
			<div class="myDataDiv">
				<div class="myDataDivData">
					<div class="myDataImgDiv">
						<el-image v-if="personInfo.thumb" class="myDataImg" :src="personInfo.thumb" />
						<img v-else src="@/assets/images/default.jpg" class="myDataImg" />
						<p>照片信息</p>
					</div>
					<div class="myDataText">
						<el-row>
							<el-col :span="12">
								<p>姓名：{{ personInfo.title }}</p>
							</el-col>
							<el-col :span="12">
								<p style="">联系电话：{{ personInfo.mobile }}</p>
							</el-col>
							<!-- <el-col :span="12">
								<p>报考院校：{{ personInfo.institution_title }}</p>
							</el-col> -->
							<el-col :span="12">
								<p style="">
									报考专业：
									<span>{{ personInfo.profession_title }}</span>
								</p>
							</el-col>
							<el-col :span="12">
								<p>准考证号：{{ personInfo.exam_number }}</p>
							</el-col>
							<el-col :span="12">
								<p style="">身份证号：{{ personInfo.identity }}</p>
							</el-col>
						</el-row>
					</div>
				</div>
				<div class="myDataButton">
					<p>若信息有误，请联系管理员</p>
					<div>
						<el-button plain @click="dialogVisible = false">取消</el-button>
						<el-button type="primary" @click="setNext()">确认</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getUserInfo } from '@/api/exam';
export default {
	name: 'myDataDialog',
	data() {
		return {
			dialogVisible: false,
			//  当前的个人信息
			personInfo: {}
		};
	},
	methods: {
		setNext() {
			this.dialogVisible = false;
			this.$emit('isValidationFace');
		},
		isOpen() {
			this.dialogVisible = !this.dialogVisible;
			if (this.dialogVisible) this.getData();
		},
		async getData() {
			const data = await getUserInfo();
			this.personInfo = data.result;
		}
	}
};
</script>

<style scoped lang="scss">
.titleDialog {
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-top: 20px;
}
.titleDialog p {
	font-size: 20px;
	color: #333;
}
.titleDialog i {
	width: 105px;
	height: 13px;
	@include bgColor('primary');
	margin-top: -12px;
	opacity: 0.37;
}
.myDataDiv {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.myDataDiv .myDataDivData {
	display: flex;
	justify-content: center;
	width: 100%;
}
.myDataDiv .myDataImgDiv {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.myDataDiv .myDataImgDiv .myDataImg {
	// width: 40%;
	width: 120px;
	// height: 150px;
}
.myDataDiv .myDataImgDiv p {
	font-size: 14px;
	color: #656565;
	margin-top: 5px;
}
.myDataDiv .myDataText {
	// width: 560px;
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	margin-left: 32px;
}
.myDataDiv .myDataText p {
	font-size: 14px;
	color: #656565;
	// width: 280px;
	margin-bottom: 20px;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.myDataDiv .myDataButton {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	// margin-left: 100px;
	margin-top: 30px;
}
.myDataDiv p {
	color: #ab1212;
}
</style>
